import React, { useState } from "react";
import { motion } from "framer-motion";
import { playAudio } from "../utils/audioManager";

function IngredientSelection({ selectedTable, onSelect, onGoBack }) {
  const ingredients = getIngredientsByTable(selectedTable.id);
  const [selectedIngredients, setSelectedIngredients] = useState({});
  const publicUrl = process.env.PUBLIC_URL || "";

  const toggleIngredient = (ingredient) => {
    setSelectedIngredients((prev) => ({
      ...prev,
      [ingredient.id]: !prev[ingredient.id],
    }));
  };

  const handleSubmit = () => {
    playAudio("/sound/GenerateTable.MP3", 1);
    const selectedItems = Object.keys(selectedIngredients)
      .filter((id) => selectedIngredients[id])
      .map((id) => ingredients.find((ingredient) => ingredient.id === id));
    onSelect(selectedItems);
  };

  return (
    <div className="p-8 bg-gradient-to-br from-blue-100 to-purple-100 rounded-xl shadow-lg">
      <div className="flex flex-col items-center mb-8">
        <button
          onClick={onGoBack}
          className="self-start bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold py-2 px-4 rounded-full focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-opacity-50"
        >
          Go Back
        </button>
        <h2 className="text-4xl font-bold text-center text-blue-800">
          Choose Your Ingredients
        </h2>
        <p className="text-lg text-gray-600 text-center mt-2">
          Select multiple ingredients to create a more diverse and authentic
          dining experience
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {ingredients.map((ingredient) => (
          <motion.button
            key={ingredient.id}
            onClick={() => toggleIngredient(ingredient)}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            className={`bg-white rounded-xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 ${
              selectedIngredients[ingredient.id] ? "ring-4 ring-blue-500" : ""
            }`}
          >
            <div className="relative">
              <img
                src={`${publicUrl}/images/ingredients/${ingredient.imageUrl}`}
                alt={ingredient.name}
                className="w-full h-48 object-cover"
              />
              {selectedIngredients[ingredient.id] && (
                <div className="absolute top-2 right-2 bg-blue-500 rounded-full p-1">
                  <span className="text-white text-xl">✓</span>
                </div>
              )}
            </div>
            <div className="p-4">
              <h3 className="font-bold text-2xl mb-2 text-blue-700">
                {ingredient.name}
              </h3>
            </div>
          </motion.button>
        ))}
      </div>
      <div className="mt-8 flex justify-center">
        <button
          onClick={handleSubmit}
          className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50"
          disabled={Object.keys(selectedIngredients).length === 0}
        >
          Next
        </button>
      </div>
    </div>
  );
}

function getIngredientsByTable(tableId) {
  const publicUrl = process.env.PUBLIC_URL || "";

  console.log("PUBLIC URL", publicUrl);

  const ingredients = [
    {
      id: "tomato",
      name: "Tomato",
      imageUrl: "tomato.jpg",
    },
    {
      id: "rice",
      name: "Rice",
      imageUrl: "rice.jpg",
    },
    {
      id: "cheese",
      name: "Cheese",
      imageUrl: "cheese.jpg",
    },
    {
      id: "chicken",
      name: "Chicken",
      imageUrl: "chicken.jpg",
    },
    {
      id: "onion",
      name: "Onion",
      imageUrl: "onion.jpg",
    },
    {
      id: "garlic",
      name: "Garlic",
      imageUrl: "garlic.jpg",
    },
    {
      id: "bell_pepper",
      name: "Bell Pepper",
      imageUrl: "bell_pepper.jpg",
    },
    {
      id: "olive_oil",
      name: "Olive Oil",
      imageUrl: "olive_oil.jpg",
    },
    {
      id: "beef",
      name: "Beef",
      imageUrl: "beef.jpg",
    },
    {
      id: "potato",
      name: "Potato",
      imageUrl: "potato.jpg",
    },
    {
      id: "carrot",
      name: "Carrot",
      imageUrl: "carrot.jpg",
    },
    {
      id: "egg",
      name: "Egg",
      imageUrl: "egg.jpg",
    },
  ];

  return ingredients;
}

export default IngredientSelection;
